// extracted by mini-css-extract-plugin
module.exports = {"years":"_1f25L","selected":"_3qM9L"};